<template>
  <div>
    {{ $t('report_tasks.runout_measurements') }}
    <b-table :data="runoutData" :striped="true" :narrowed="true">
      <template slot-scope="props">
        <b-table-column field="label" :label="$t('report_tasks.label_uc')">
          {{ props.row.label }}
        </b-table-column>
        <b-table-column
          field="partName"
          :label="$t('report_tasks.part_name_uc')"
          v-if="hasPartNameColumn(runoutData)"
        >
          {{ props.row.partName }}
        </b-table-column>

        <b-table-column
          field="description"
          :label="$t('report_tasks.description_uc')"
          v-if="hasDescriptionColumn(runoutData)"
        >
          {{ props.row.description ?? '-' }}
        </b-table-column>

        <b-table-column
          v-if="props.row.values.length > 0"
          v-for="item in props.row.values"
          :field="item.name"
          :label="item.name"
          :class="
            props.row.hasMultipleMeasurements
              ? undefined
              : 'col-value' + colorValueDimLen(item.diff || item.diffConverted)
          "
        >
          {{
            item.name === 'Position' || unit === item.inputUnit
              ? item.value
              : item.valueConverted
          }}
          <template
            v-if="isInternalReport && !props.row.hasMultipleMeasurements"
          >
            <div>
              {{ unit === item.inputUnit ? item.diff : item.diffConverted }}
            </div>
          </template>
        </b-table-column>

        <b-table-column
          v-if="props.row.hasMultipleMeasurements"
          field="tir"
          :label="$t('report_tasks.tir')"
          :class="'col-value' + colorValueDimLen(props.row.tirDiff)"
        >
          {{ unit === props.row.unit ? props.row.tir : props.row.tirConverted }}
          <template v-if="props.row.tirDiff && isInternalReport">
            <div>
              {{
                unit === props.row.unit
                  ? props.row.tirDiff
                  : props.row.tirDiffConverted
              }}
            </div>
          </template>
        </b-table-column>

        <b-table-column
          field="expectedValue"
          :label="$t('report_tasks.tolerance')"
          :visible="isInternalReport"
        >
          {{
            unit === props.row.unit
              ? props.row.expectedValue
              : props.row.expectedValueConverted
          }}
        </b-table-column>

        <b-table-column field="unit" :label="$t('report_tasks.unit')">
          {{ unit }}
        </b-table-column>

        <b-table-column
          field="lastModifiedBy"
          :label="$t('report_tasks.inspector_title')"
          :visible="isInternalReport"
        >
          {{ props.row.lastModifiedBy }}
        </b-table-column>

        <b-table-column
          field="lastModifiedAt"
          :label="$t('report_tasks.date_title')"
        >
          {{ props.row.lastModifiedAt }}
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    runoutData: {},
    isInternalReport: {},
    colorValueDimLen: {},
    unit: {
      type: String,
      required: true,
    },
  },
  name: 'RunoutReportTable',
  methods: {
    hasDescriptionColumn(measurements) {
      return measurements.some((measurement) => measurement.hasDescription);
    },
    hasPartNameColumn(measurements) {
      return measurements.some((measurement) => measurement.inTable);
    },
  },
};
</script>
<style scoped>
.red-value {
  color: #e87061;
}
</style>
